__turbopack_context__.v({
  "card": "lZvRwW_card",
  "cardContent": "lZvRwW_cardContent",
  "postContent": "lZvRwW_postContent",
  "repliedTo": "lZvRwW_repliedTo",
  "textContent": "lZvRwW_textContent",
  "title": "lZvRwW_title",
});
